// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rectangle {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 69px;
  height: 24px;
  border-radius: 6px;
  flex: none;
  order: 0;
  flex-grow: 0;
  font-size: 10px;
  background-color: #6c757d;
  color: #fff;
}
.rectangle.active {
  background: #22bb9c;
  color: #fff;
}
.rectangle.inactive {
  color: #22bb9c;
  background: #2f3d3a;
}`, "",{"version":3,"sources":["webpack://./src/Components/Rectangle/rectangle.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EAEA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EAEA,yBAAA;EACA,WAAA;AAHF;AAKE;EACE,mBAAA;EACA,WAAA;AAHJ;AAKE;EACE,cAAA;EACA,mBAAA;AAHJ","sourcesContent":[".rectangle {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n\n  width: 69px;\n  height: 24px;\n\n  border-radius: 6px;\n\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  font-size: 10px;\n\n  background-color: #6c757d;\n  color: #fff;\n\n  &.active {\n    background: #22bb9c;\n    color: #fff;\n  }\n  &.inactive {\n    color: #22bb9c;\n    background: #2f3d3a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
